import React, { Component } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
//import $ from "jquery";
import {
  FormattedMessage,
  FormattedHTMLMessage,
  IntlProvider,
} from "react-intl";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./includes/Footer";
import Register from "./includes/Register";
import { history } from "../helper/History";
import $ from "jquery";
//import { FormattedHTMLMessage } from "react-intl";

class Youcompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dis: "",
    };
    window.scrollTo(0, 0); // scroll page to top
  }
  // componentDidMount(){
  //   if (this.props.isSignedIn) {

  //     this.setState({dis:"none"});
  //   }
  //   console.log(this.state.dis);
  // }

  showRegister(e) {
    var userType = localStorage.getItem("role");
    if (!userType) {
      history.push("/register");
      // console.log('in '+e);
      // $("#loginModal").modal("show");
      // $("#register-form").delay(100).fadeIn(100);
      // $("#login-form").fadeOut(100);
      // $("#login-form-link").removeClass("active");
      // console.log('Inside Header '+e);
      // if(e === '#register-form-link'){
      //   $('.modal-title').text('SIGNUP');
      //   $(e).addClass("active");
      // }else{
      //   $(e.target).addClass("active");
      // }
    }
  }

  sendparam() {
    localStorage.setItem("classic", "classic");
  }
  showRegister2(e) {
    console.log("in " + e);
    $("#loginModal").modal("show");
    $("#register-form").delay(100).fadeIn(100);
    $("#login-form").fadeOut(100);
    $("#login-form-link").removeClass("active");
    console.log("Inside Header " + e);
    if (e === "#register-form-link") {
      $(".modal-title").text("SIGNUP");
      $(e).addClass("active");
    } else {
      $(e.target).addClass("active");
    }
  }
   setSkillsNavigation() {
    localStorage.setItem("navigation", "enterprise");
  }

  render() {
     const userRole = localStorage.getItem("userRole");
    return (
      <React.Fragment>
        <section id="wrapper" className="icon-boxed1 teaser-box consultant-hero-section">
           {userRole && (
              <Link to="/youareacompany" onClick={this.setSkillsNavigation.bind(this)}>
                <div
                  className="white-btns-hr consultant-btn "
                  style={{
                    backgroundColor: "#003366",
                    color: "white",
                    width: "370px",
                    marginTop: "5%",
                    borderRadius: "5px",
                    height: "65px"
                  }}
                >
                  <div>
                    <FormattedHTMLMessage
                        id={userRole === "User" ? "sub.menue" : userRole === "Hr" ? "sub.menue1" : userRole === "Enterprise" ? "sub.menue2" : "sub.menue"}
                      defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                    />
                  </div>
                </div>
              </Link>
            )}

          <div className="container company-content-area">
            <div className="consultant-cards-wrap">
              <Link to="/hr" style={{ textDecoration: "none" }} onClick={this.setSkillsNavigation.bind(this)}>
                <div className="consultant-card">
                  <div className="consultant-card-icon">⬢</div>
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.company.card.left.title"
                      defaultMessage="starter"
                    />
                  </h3>
                  <div className="company-card-divider"></div>
                  <div
                    className="company-card-content"
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0, color: "#ffffff", fontWeight: 700 }}>
                      <FormattedHTMLMessage
                        id="you.company.card.left.body"
                        defaultMessage="12 months"
                      />
                    </p>
                  </div>
                  <button className="consultant-discover-btn">
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>
              <Link to="/pre-registration" style={{ textDecoration: "none" }} onClick={this.setSkillsNavigation.bind(this)} >
                <div className="consultant-card">
                  <div className="consultant-card-icon">◈</div>
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.company.card.middle.title"
                      defaultMessage="Classic"
                    />
                  </h3>
                  <div className="company-card-divider"></div>
                  <div
                    className="company-card-content"
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0, color: "#ffffff", fontWeight: 700 }}>
                      {userRole ? (
                        <FormattedHTMLMessage
                        id="you.company.card.middle.body"
                        defaultMessage="€49.90"
                      />

                      ) : (
                      <FormattedHTMLMessage
                        id="you.company.card.middle.body"
                        defaultMessage="€49.90"
                      />
                      )}
                    </p>
                  </div>
                  <button
                    className="consultant-discover-btn"
                    onClick={this.sendparam()}
                  >
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>
              <Link to="/individual" style={{ textDecoration: "none" }} onClick={this.setSkillsNavigation.bind(this)}>
                <div className="consultant-card">
                  <div className="consultant-card-icon">✦</div>
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.company.card.right.title"
                      defaultMessage="Classic"
                    />
                  </h3>
                  <div className="company-card-divider"></div>
                  <div
                    className="company-card-content"
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  > 

                    <p style={{ margin: 0, color: "#ffffff", fontWeight: 700 }}>
                      {userRole ? (
                        <FormattedHTMLMessage
                        id="you.company.card.right.body"
                        defaultMessage="€49.90"
                      />

                      ) : (
                      <FormattedHTMLMessage
                        id="you.company.card.right.body"
                        defaultMessage="€49.90"
                      />
                      )}
                    </p>
                  
                  </div>
                  <button
                    className="consultant-discover-btn"
                    onClick={this.sendparam()}
                  >
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>
              {/* <div className="col-lg-3 col-md-6 responsive-mb" style={{ marginLeft: "-57px" }}>
                <Link to="/coachingoffer" style={{ textDecoration: "none" }}>
                  <div className="icon-box text-left hero-bg box-shadow boxHeight">
                    <div>
                      <p class="text-center">
                       
                        <b>
                          <FormattedHTMLMessage
                            id="you.company.title4"
                            defaultMessage="Premium"
                          />
                        </b>
                       
                      </p>
                      <p style={{ color: "white" }}>
                        <FormattedHTMLMessage
                          id="you.company.card4"
                          defaultMessage="12 months"
                        />
                      </p>
                    </div>
                    <div class="BtnBotm">
                      <Link
                        to="/coachingoffer"
                        className="nav-link text-center"
                        data-target=".navbar-collapse.show"
                      >
                        <button class="btn btn-primary btnDiscover ">
                          <FormattedHTMLMessage
                            id="Discover"
                            defaultMessage="Subscribe"
                          />
                        </button>
                      </Link>
                    </div>
                  </div>
                </Link>
              </div> */}
              {/* <div className="col-lg-3 col-md-6 responsive-mb" style={{ marginLeft: "-57px" }}>
                <Link to="/individual" style={{ textDecoration: "none" }}>
                  <div className="icon-box text-left hero-bg box-shadow boxHeight" style={{ padding:"19px" }}>
                    <div>
                      <p class="text-center">
                       
                        <b>
                          <FormattedHTMLMessage
                            id="you.company.title5"
                            defaultMessage="Premium"
                          />
                        </b>
                      
                      </p>
                      <p style={{ color: "white" }}>
                        <FormattedHTMLMessage
                          id="you.company.card5"
                          defaultMessage="12 months"
                        />
                      </p>
                    </div>
                    <div class="BtnBotm">
                      <Link
                        to="/individual"
                        className="nav-link text-center"
                        data-target=".navbar-collapse.show"
                      >
                        <button class="btn btn-primary btnDiscover ">
                          <FormattedHTMLMessage
                            id="Discover"
                            defaultMessage="Subscribe"
                          />
                        </button>
                      </Link>
                    </div>
                  </div>
                </Link>
              </div> */}
              <div className="col-lg-2 col-md-3 responsive-mb company-pdf-links" style={{ display:"none", width: "100%" }}>
                <a href="/assets/pdf/PILOTRH_Grand_Groupe.pdf" style={{ textDecoration: "none" }} target="_blank">
                  <div className="icon-box text-left hero-bg box-shadow" style={{ width: "100%", height: "40%", marginTop: "17%", background: "#fff" }}>
                    <div >
                      <p className=" text-center " >
                        <b style={{ color: "#000", fontSize: "15px" }}>
                          <FormattedHTMLMessage
                            id="big_group_pdf1"
                            defaultMessage="pdf"

                          /></b><br />
                        <img
                          className="" style={{ width: "100%" }}
                          src="assets/images/pdf.jpg"
                          alt=""
                        />
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div
              className="white-btn hero-btn full-width-text"
              style={{
                background: "#000",
                color: "#fff",
                width: "100%",
                padding: "15px",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "4px"
              }}
            >
              <p className="text-center font22" style={{ margin: 0, fontWeight: "bold" }}>
                <FormattedHTMLMessage id="you.company.banner" />
              </p>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default Youcompany;
